/**
 * Internal Dependencies
 */
import * as editor from './editor/post-types';
import * as forms from './forms';
import * as plugins from './plugins';
export { default } from './reducers';

export { editor, forms, plugins };